import { GameSettingTypesEnum } from '../../enums';

export const GAMES_WITHOUT_BORDER_SHADOW: GameSettingTypesEnum[] = [GameSettingTypesEnum.ADVENT_CALENDAR];
